import { render } from "./WhatsAppInbox.vue?vue&type=template&id=493bcf36"
import script from "./WhatsAppInbox.vue?vue&type=script&lang=js"
export * from "./WhatsAppInbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__